import { useMemo } from "react";

import SubscriptionService
from "../services/subscription/SubscriptionService";

const useSubscription = (user) => {

    const plan = useMemo(() => {

        if (!user?.expireDate) {

            return "free";

        }

        const today = new Date();

        const expireDate = new Date(
            user.expireDate
        );

        if (expireDate <= today) {

            return "free";

        }

        const registerDate = new Date(
            user.registerDate
        );

        const totalDays = Math.round(

            (expireDate - registerDate) /

            (1000 * 60 * 60 * 24)

        );

        if (totalDays <= 32) {

            return "trial";

        }

        return "pro";

    }, [user]);

    return {

        plan,

        isFree: plan === "free",

        isTrial: plan === "trial",

        isPro: plan === "pro",

        canUse: (feature, currentCount = 0) =>

            SubscriptionService.canUse(

                plan,

                feature,

                currentCount

            ),

        remaining: (

            feature,

            currentCount = 0

        ) =>

            SubscriptionService.remaining(

                plan,

                feature,

                currentCount

            ),

        limit: (feature) =>

            SubscriptionService.getLimit(

                plan,

                feature

            ),

    };

};

export default useSubscription;